"use client";

import Image from "next/image";
import { useState } from "react";
import { SECTORS, SECTION_IDS } from "./content";
import { cn } from "@/app/utils/className";

export const Sectors = () => {
  const [active, setActive] = useState(0);
  const sector = SECTORS[active];

  return (
    <section
      id={SECTION_IDS.sectors}
      className="relative border-t border-white/[.07]"
    >
      <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,400px),1fr))] items-stretch">
        <div className="flex flex-col justify-center bg-ink-2 px-[clamp(16px,4vw,64px)] py-[clamp(80px,10vw,170px)]">
          <h2 className="mt-0 mb-[34px] max-w-[16ch] text-[clamp(34px,4.6vw,76px)] font-bold leading-[.98] tracking-[-.04em] text-balance">
            Know what is happening across more ground than anyone can cover.
          </h2>

          <div
            role="tablist"
            aria-label="Sectors"
            className="mb-[34px] flex flex-wrap gap-2"
          >
            {SECTORS.map((item, index) => {
              const isActive = index === active;
              return (
                <button
                  key={item.key}
                  type="button"
                  role="tab"
                  id={`sector-tab-${index}`}
                  aria-selected={isActive}
                  aria-controls="sector-panel"
                  onClick={() => setActive(index)}
                  className={cn(
                    "dc-mono cursor-pointer border px-4 py-2.5 text-[12px] uppercase tracking-[.14em] transition-colors duration-300",
                    isActive
                      ? "border-mint bg-mint text-ink"
                      : "border-white/[.24] bg-transparent text-mist-2 hover:border-mint/60 hover:text-paper"
                  )}
                >
                  {item.key}
                </button>
              );
            })}
          </div>

          <div id="sector-panel" role="tabpanel" aria-labelledby={`sector-tab-${active}`}>
            <h3 className="mt-0 mb-4 max-w-[24ch] text-[clamp(20px,2vw,28px)] font-semibold leading-[1.18] tracking-[-.022em]">
              {sector.title}
            </h3>
            <p className="mt-0 mb-[26px] max-w-[50ch] text-base leading-[1.7] text-mist-2">
              {sector.body}
            </p>
            <ul className="m-0 grid max-w-[52ch] list-none p-0">
              {sector.points.map((point) => (
                <li
                  key={point}
                  className="border-t border-white/[.12] py-3.5 text-[15px] leading-[1.6] text-mist-3"
                >
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="relative min-h-[clamp(420px,64vw,940px)] overflow-hidden">
          {SECTORS.map((item, index) => (
            <Image
              key={item.key}
              src={item.img}
              alt={item.alt}
              fill
              sizes="(max-width: 800px) 100vw, 50vw"
              className={cn(
                "object-cover transition-opacity duration-700",
                index === active ? "opacity-100" : "opacity-0"
              )}
            />
          ))}

          <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(5,15,28,.92)_0%,rgba(5,15,28,.18)_34%,transparent_70%)]" />
          <div
            className="absolute inset-0 opacity-30"
            style={{
              backgroundImage:
                "linear-gradient(rgba(127,232,180,.4) 1px, transparent 1px), linear-gradient(90deg, rgba(127,232,180,.4) 1px, transparent 1px)",
              backgroundSize: "90px 90px",
            }}
          />
          <div className="absolute inset-y-0 w-[18%] bg-[linear-gradient(90deg,transparent,rgba(127,232,180,.14),transparent)] [animation:dc-sweep-x_7s_linear_infinite]" />

          <div className="absolute left-[8%] top-[14%] h-[30%] w-[34%] border border-mint/50">
            <span className="absolute -left-px -top-px h-3 w-3 border-l-2 border-t-2 border-mint" />
            <span className="absolute -bottom-px -right-px h-3 w-3 border-b-2 border-r-2 border-mint" />
            <span className="dc-mono absolute left-0 -top-[22px] text-[12px] tracking-[.16em] text-mint">
              AREA OF INTEREST
            </span>
          </div>

          <div className="dc-mono absolute left-[26px] top-[26px] text-[12px] uppercase leading-[2] tracking-[.18em] text-paper/70">
            DATA LAYER 0{active + 1}
            <br />
            OBSERVATION 1987–2026
          </div>
          <div className="dc-mono absolute bottom-6 right-[26px] text-right text-[12px] uppercase leading-[2] tracking-[.18em] text-paper/80">
            {sector.kicker}
            <br />
            <span className="text-mint">{sector.source}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
